var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn btn-' + _vm.tipo],attrs:{"type":"button"},on:{"click":_vm.telaCheia}},[(_vm.icone)?_c('i',{class:['fa fa-'+ _vm.icone]}):_vm._e(),_vm._v(" "+_vm._s(_vm.texto)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b94561","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/TelaCheia.vue
// module id = 2093
// module chunks = 0